import { render, staticRenderFns } from "./PersonalizeOnboardSection.vue?vue&type=template&id=492a6c23&scoped=true"
import script from "./PersonalizeOnboardSection.vue?vue&type=script&lang=js"
export * from "./PersonalizeOnboardSection.vue?vue&type=script&lang=js"
import style0 from "./PersonalizeOnboardSection.vue?vue&type=style&index=0&id=492a6c23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492a6c23",
  null
  
)

export default component.exports